/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { IconLinkTabsComponentEditor } from "cms/components/components/icon-link-tabs/edit";
import { IconLinkTabsComponentDisplay } from "cms/components/components/icon-link-tabs/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const IconLinkTabsComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <IconLinkTabsComponentDisplay />,
        editComponent: <IconLinkTabsComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

IconLinkTabsComponent.displayName = "IconLinkTabsComponent";
export { IconLinkTabsComponent };
